import PropTypes from 'prop-types'

import { MONTH_TYPE_LIST } from 'util/Constant/BaseConstantList'

const MonthTypePropType = PropTypes.oneOf(MONTH_TYPE_LIST)

export default MonthTypePropType
